<div class="body">

    <div class="content" [class.center]="center">

        <ng-container *ngFor="let user of (users$|async)">

            <div class="entry-wrapper" [class.disabled]="userControl.disabled" (click)="toggleAssignment(user)">

                <mat-slide-toggle class="toggle" [checked]="userScheduleReadOnly[user.id]" (click)="$event.preventDefault()"></mat-slide-toggle>
                <app-user-preview2 class="entry" [user]="user"></app-user-preview2>

            </div>
    
        </ng-container>

    </div>
    
</div>